import React from 'react';
import { Fuel, Award, Crown, Check } from 'lucide-react';

const ThreeTierProgram = () => {
  return (
    <section className="relative py-24 bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full px-6 py-2 mb-6">
            <Fuel className="w-5 h-5 text-[#D4AF37]" />
            <span className="text-[#D4AF37] font-bold text-sm">THREE-TIER PROGRAM</span>
          </div>
          <h2 className="text-5xl sm:text-6xl md:text-7xl font-bold text-white mb-6" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
            CHOOSE YOUR
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] to-[#FFD700]">
              TRANSFORMATION LEVEL
            </span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Three pathways to freedom. One transformative journey.
          </p>
        </div>

        {/* Three Tiers */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          {/* UNLEADED - Blue */}
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border-2 border-[#3B82F6] rounded-2xl p-8 transform hover:scale-105 transition-all duration-300 hover:shadow-2xl hover:shadow-[#3B82F6]/20">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-gradient-to-br from-[#3B82F6] to-[#60A5FA] rounded-lg flex items-center justify-center">
                  <Fuel className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="text-2xl font-bold text-[#3B82F6]" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                    🔵 UNLEADED
                  </div>
                </div>
              </div>
              <div className="text-right">
                <div className="text-3xl font-bold text-white" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>12</div>
                <div className="text-sm text-gray-400">weeks</div>
              </div>
            </div>

            <div className="mb-6">
              <h4 className="text-xl font-bold text-white mb-4" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                FOUNDATION LEVEL
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-[#3B82F6] flex-shrink-0 mt-0.5" />
                  <span className="text-gray-300">Gasoline One workbook</span>
                </li>
                <li className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-[#3B82F6] flex-shrink-0 mt-0.5" />
                  <span className="text-gray-300">12-week structured curriculum</span>
                </li>
                <li className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-[#3B82F6] flex-shrink-0 mt-0.5" />
                  <span className="text-gray-300">Weekly progress tracking</span>
                </li>
              </ul>
            </div>

            <div className="bg-[#3B82F6]/10 border border-[#3B82F6]/30 rounded-lg p-4">
              <div className="flex items-center space-x-2 mb-2">
                <Award className="w-5 h-5 text-[#3B82F6]" />
                <span className="font-bold text-white text-sm">COMPLETION REWARD</span>
              </div>
              <p className="text-gray-300 text-sm">Reward ticket upon successful completion</p>
            </div>
          </div>

          {/* PREMIUM - Purple */}
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border-2 border-[#A855F7] rounded-2xl p-8 transform hover:scale-105 transition-all duration-300 hover:shadow-2xl hover:shadow-[#A855F7]/20 relative">
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-[#A855F7] text-white px-4 py-1 rounded-full text-xs font-bold">
              POPULAR
            </div>
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-gradient-to-br from-[#A855F7] to-[#C084FC] rounded-lg flex items-center justify-center">
                  <Fuel className="w-6 h-6 text-white" />
                </div>
                <div>
                  <div className="text-2xl font-bold text-[#A855F7]" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                    🟣 PREMIUM
                  </div>
                </div>
              </div>
              <div className="text-right">
                <div className="text-3xl font-bold text-white" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>28</div>
                <div className="text-sm text-gray-400">weeks</div>
              </div>
            </div>

            <div className="mb-6">
              <h4 className="text-xl font-bold text-white mb-4" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                ADVANCED LEVEL
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-[#A855F7] flex-shrink-0 mt-0.5" />
                  <span className="text-gray-300">Gasoline Two workbook</span>
                </li>
                <li className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-[#A855F7] flex-shrink-0 mt-0.5" />
                  <span className="text-gray-300">Epigenetics curriculum</span>
                </li>
                <li className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-[#A855F7] flex-shrink-0 mt-0.5" />
                  <span className="text-gray-300">Victim-Offender Dialogue training</span>
                </li>
                <li className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-[#A855F7] flex-shrink-0 mt-0.5" />
                  <span className="text-gray-300">28-week comprehensive program</span>
                </li>
              </ul>
            </div>

            <div className="bg-[#A855F7]/10 border border-[#A855F7]/30 rounded-lg p-4">
              <div className="flex items-center space-x-2 mb-2">
                <Award className="w-5 h-5 text-[#A855F7]" />
                <span className="font-bold text-white text-sm">COMPLETION REWARD</span>
              </div>
              <p className="text-gray-300 text-sm">Advanced certification + community leadership role</p>
            </div>
          </div>

          {/* SUPREME - Gold */}
          <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0f0f0f] border-2 border-[#D4AF37] rounded-2xl p-8 transform hover:scale-105 transition-all duration-300 hover:shadow-2xl hover:shadow-[#D4AF37]/20">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-gradient-to-br from-[#D4AF37] to-[#FFD700] rounded-lg flex items-center justify-center">
                  <Crown className="w-6 h-6 text-[#0a0a0a]" />
                </div>
                <div>
                  <div className="text-2xl font-bold text-[#D4AF37]" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                    🟡 SUPREME
                  </div>
                </div>
              </div>
              <div className="text-right">
                <div className="text-3xl font-bold text-white" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>20</div>
                <div className="text-sm text-gray-400">weeks</div>
              </div>
            </div>

            <div className="mb-6">
              <h4 className="text-xl font-bold text-white mb-4" style={{ fontFamily: '"Bebas Neue", sans-serif' }}>
                MASTERY LEVEL
              </h4>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                  <span className="text-gray-300">Gasoline Three workbook</span>
                </li>
                <li className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                  <span className="text-gray-300">Living Amends practice</span>
                </li>
                <li className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                  <span className="text-gray-300">ZOE Fraternity membership</span>
                </li>
                <li className="flex items-start space-x-3">
                  <Check className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                  <span className="text-gray-300">20-week intensive program</span>
                </li>
              </ul>
            </div>

            <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-lg p-4">
              <div className="flex items-center space-x-2 mb-2">
                <Crown className="w-5 h-5 text-[#D4AF37]" />
                <span className="font-bold text-white text-sm">REQUIREMENT</span>
              </div>
              <p className="text-gray-300 text-sm font-semibold">Must Sponsor a Transformation ($60) to complete</p>
            </div>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center bg-gradient-to-r from-[#1a1a1a] via-[#D4AF37]/10 to-[#1a1a1a] border border-[#D4AF37]/30 rounded-2xl p-8">
          <p className="text-2xl text-white font-semibold mb-2">
            All three levels included in every $60 sponsorship
          </p>
          <p className="text-gray-400">
            Recipients choose their path and can progress through all tiers
          </p>
        </div>
      </div>
    </section>
  );
};

export default ThreeTierProgram;
